import React, { useState } from 'react';
import { Box, Flex, Grid, Image, Text, IconButton, useBreakpointValue, Modal, ModalOverlay, ModalContent } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon, CloseIcon } from '@chakra-ui/icons';

interface ImageItem {
  img: string;
  title: string;
  description: string;
}

const images: ImageItem[] = [
  { img: '1', description: 'Creation d’un logo et illustration pour une application metier chez Pickup-service 2023. Réalisation Illustrator', title: 'CyclopE pickup-services' },
  { img: '2', description: 'Realisation Midjourney Inspiration de Yangza2', title: 'Humanoid' },
  { img: '3', description: 'illustration vectoriel Collorisation par pollygones', title: 'Mac’n’cheese' },
  { img: '4', description: 'Etude de composants et gamification pour un projet de jeux mobile', title: 'Projet quiz' },
  { img: '5', description: 'Illustration VIA MIDJOURNEY', title: 'Portrait d aurelie' },
  { img: '6', description: 'illustration vectoriel Flat DESIGN', title: 'FASHion victim' },
  { img: '7', description: 'illustration vectoriel FLATDESIGN', title: 'Lucie' },
  { img: '8', description: 'Midjourney Recherche pour le projet nature Morte 2025', title: 'Nature MORTE' },
  { img: '9', description: 'illustration Midjourney pour un Test pour actoon', title: 'Lucie' },
  { img: '10', description: 'six illustrations T-SHIRT par vecteur pour la promotion d’un evenement séminaire Pickup 2023', title: 'Illustration promotion pickup-services' },
  { img: '11', description: 'Réalisation Midjourney pour LE FESTIVAL ARKHAM 2025', title: 'COsplay' },
  { img: '12', description: 'Creation VIA MIDJOURNEY pour un personna', title: 'PASCAL LE PERSONNA' },
];

const ProjetPerso: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const openImage = (index: number) => {
    setSelectedIndex(index);
  };

  const closeImage = () => {
    setSelectedIndex(null);
  };

  const showPrev = () => {
    setSelectedIndex(prev => (prev !== null ? (prev - 1 + images.length) % images.length : null));
  };

  const showNext = () => {
    setSelectedIndex(prev => (prev !== null ? (prev + 1) % images.length : null));
  };

  const currentImage = selectedIndex !== null ? images[selectedIndex] : null;

  return (
    <Flex justifyContent="center" direction="column" alignItems="center" h="100%">
      <Grid templateColumns={isMobile ? 'repeat(3, 1fr)' : 'repeat(6, 1fr)'} gap={2}>
        {images.map((image, index) => (
          <Box key={image.img} onClick={() => openImage(index)} cursor="pointer">
            <Image src={`/medias/perso1/miniatures/${image.img}.png`} alt={image.title} />
          </Box>
        ))}
      </Grid>

      <Modal isOpen={selectedIndex !== null} onClose={closeImage} size="6xl" isCentered>
        <ModalOverlay bg="rgba(0, 0, 0, 0.95)" />
        <ModalContent bg="transparent" boxShadow="none" position="relative" p={4}>
          {/* Croix de fermeture en haut à droite de l'écran */}
          <IconButton icon={<CloseIcon />} aria-label="Fermer" position="fixed" top="20px" right="20px" zIndex="modal" colorScheme="whiteAlpha" onClick={closeImage} />

          {/* Flèche gauche */}
          <IconButton
            icon={<ArrowBackIcon />}
            aria-label="Image précédente"
            position="fixed"
            left="20px"
            top="50%"
            transform="translateY(-50%)"
            zIndex="modal"
            colorScheme="whiteAlpha"
            onClick={showPrev}
          />

          {/* Flèche droite */}
          <IconButton
            icon={<ArrowForwardIcon />}
            aria-label="Image suivante"
            position="fixed"
            right="20px"
            top="50%"
            transform="translateY(-50%)"
            zIndex="modal"
            colorScheme="whiteAlpha"
            onClick={showNext}
          />

          {/* Image et texte */}
          {currentImage && (
            <Flex direction="column" alignItems="center" color="white" position="relative" mt={10}>
              <Text fontSize="2xl" mb={4}>
                {currentImage.title}
              </Text>
              <Image src={`/medias/perso1/big/${currentImage.img}.png`} alt={currentImage.title} maxH="70vh" objectFit="contain" />
              <Text fontSize="md" mt={4} maxW="80%" textAlign="center">
                {currentImage.description}
              </Text>
            </Flex>
          )}
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default ProjetPerso;
